module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.collabUser) ? _c('md-avatar', [(_vm.collabUser.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.collabUser.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.collabUser) ? _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collabUser.username))])]), _vm._v(" "), (_vm.collaborator.role) ? _c('span', [_vm._v(_vm._s(_vm.collaborator.role))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collabUser.email))])]) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-layout', {
    staticClass: "heading-align",
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Layer Permissions")])])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "sub-list"
  }, [_c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Edit")])])], 1), _vm._v(" "), _c('span', [_vm._v("Layer Name")])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "sub-list"
  }, _vm._l((_vm.layers), function(layer) {
    return _c('layer-permission', {
      key: layer.id,
      attrs: {
        "layer": layer,
        "editable": _vm.editable,
        "collaborator": _vm.collaborator
      }
    })
  }))], 1), _vm._v(" "), (_vm.user.uid === _vm.collaborator.uid || _vm.editable) ? _c('md-button', {
    on: {
      "click": _vm.removeCollaborator
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v("\r\n            Remove From Project\r\n        ")], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95349950","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/collaborators/collaborator.vue
// module id = 670
// module chunks = 2